import axios from 'axios'
import { API_CLIENT_PROCESS, API_REGISTER_PROCESS, API_STRUCTURE, AesGCMTagEncrypted } from '../../config/config.json'
import { decryptGCM, decryptStorage } from 'utils/utils';
import { encryptAES } from 'utils/generalUtils';
export async function getProcessData(data) {
  let token = decryptStorage(localStorage.getItem("token"))
  let config = {
    method: 'post',
    url: `${API_CLIENT_PROCESS}/Consult/getprocessinformation`,
    headers: {
      'Authorization': 'Bearer ' + token,
      'Content-Type': 'application/json'
    }, data
  };
  return axios.request(config)
    .then(response => {
      return response.data.data
    }).catch(error => {
      console.log(error)
    });
}

export async function getVerificationData(data) {
  let token = decryptStorage(localStorage.getItem("token"))
  let config = {
    method: 'post',
    url: `${API_CLIENT_PROCESS}/Consult/getprocessverification`,
    headers: {
      'Authorization': 'Bearer ' + token,
      'Content-Type': 'application/json'
    }, data
  };
  return axios.request(config)
    .then(response => {
      return response.data.data
    }).catch(error => {
      console.log(error)
    });
}

export async function getHistoricData(data) { 
  let token = decryptStorage(localStorage.getItem("token"))
  let config = {
    method: 'post',
    url: `${API_CLIENT_PROCESS}/Consult/getstatushistory`,
    headers: {
      'Authorization': 'Bearer ' + token,
      'Content-Type': 'application/json'
    }, data
  };
  return axios.request(config)
    .then(response => {
      return response.data.data
    }).catch(error => {
      console.log(error)
    });
}

export async function registerFormClient(data) {
  let token = decryptStorage(localStorage.getItem("token"))
  let config = {
    method: 'post',
    url: `${API_REGISTER_PROCESS}/ECD/registerCertificateRequest`,
    headers: {
      'Authorization': 'Bearer ' + token,
      'Content-Type': 'application/json'
    }, data
  };
  return axios.request(config)
    .then(response => {
      return response.data.data
    }).catch(error => {
      console.log(error)
    });
}

export async function getRequestData(data) {
  let token = decryptStorage(localStorage.getItem("token"))
  let tagDecrypted = decryptStorage(AesGCMTagEncrypted)
  let config = {
    method: 'post',
    url: `${API_CLIENT_PROCESS}/Consult/getprocessreference`,
    headers: {
      'Authorization': 'Bearer ' + token,
      'Content-Type': 'application/json'
    }, data
  };
  return axios.request(config)
  .then(response => {
      return decryptGCM(response.data.data,tagDecrypted)
    }).catch(error => {
      console.log(error)
    });
}

export async function getStructureConsult(data) {
  let token = decryptStorage(localStorage.getItem("token"))
  let config = {
    method: 'get',
    url: `${API_STRUCTURE}/structure-product-info`,
    headers: {
      'Authorization': 'Bearer ' + token,
      'Content-Type': 'application/json',
      "productid" : data.productId
    },
  };
  return await axios.request(config)
    .then(response => {
      return { data: response.data.data, status: 'success' }
    }).catch(error => {
      return { data: { message: error.message }, status: 'error' }
    });
}

export async function updateStatusApi(data) {
  let token = decryptStorage(localStorage.getItem("token"))
  let config = {
    method: 'post',
    url: `${API_CLIENT_PROCESS}/ECD/UpdateStatus`,
    headers: {
      'Authorization': 'Bearer ' + token,
      'Content-Type': 'application/json'
    },
    data
  };
  return axios.request(config)
    .then(response => {
      return response.data.data
    }).catch(error => {
      console.log("-------ERROR IDENTIFICADO:", error)
    });
}

export async function StatusResultIdentityApi(data) {
  let token = decryptStorage(localStorage.getItem("token"))
  let config = {
    method: 'post',
    url: `${API_CLIENT_PROCESS}/ECD/StatusResultIdentity`,
    headers: {
      'Authorization': 'Bearer ' + token,
      'Content-Type': 'application/json'
    },
    data
  };
  return axios.request(config)
    .then(response => {
      return response.data.data
    }).catch(error => {
      console.log("-------ERROR IDENTIFICADO:", error)
    });
}

export async function issueCertificate(data) {
  let token = decryptStorage(localStorage.getItem("token"))
  let config = {
    method: 'post',
    url: `${API_REGISTER_PROCESS}/ECD/ecdissuecertificate`,
    headers: {
      'Authorization': 'Bearer ' + token,
      'Content-Type': 'application/json',
      'securityToken': await encryptAES(await decryptStorage(localStorage.getItem("tokenSecurity")))
    }, data
  };
  return axios.request(config)
    .then(response => {
      return response.data
    }).catch(error => {
      let dataError = error.response.data.data;
      let responseMessage = dataError.responseMessage;
      if(dataError && responseMessage){
        if (responseMessage.includes("CertificateCreateException") ||
        responseMessage.includes("CryptoTokenOfflineException") || 
        responseMessage.includes("Error invocando") ||
        responseMessage.includes("The server didn't respond in time.") ||
        responseMessage.includes("One or more errors occurred. (A task was canceled.)")
        ){
          return { data:'Fallo en la PKi' }
        } else if (responseMessage === "One or more errors occurred. (The SSL connection could not be established, see inner exception.)") {
          return { data:'Falló en la generación del documento' }
        } else if (responseMessage.includes("SQL Server")) {
          return { data:'Falló ejecutando solicitud' }
        } else {
          let errorData = "";
          if(responseMessage !== undefined){
            errorData = responseMessage;
          } else if(error.response.data.statusDescription){
            errorData = error.response.data.statusDescription;
          } else {
            errorData = 'Falló ejecutando solicitud'
          }
          return { data: {"message": errorData, "statusCode": dataError.responseCode } }
        }
      } else {
        if(error.response.data){
          return error.response.data;
        } else {
          return { data:'Falló ejecutando solicitud' }
        }
      }
    });
}

export async function consultFlagValidateEmail(data) {
  const headers = { Authorization: `Bearer ${decryptStorage(localStorage.getItem("token"))}` };
  return await axios.post(`${API_STRUCTURE}/consult-general-flag-validate-email`, data, { headers }).then(res => {

    let validateEmail = res.data && res.data.data && res.data.data.valueFlag ? res.data.data.valueFlag : "0";
    return { data: { validateEmail }, status: 'success' }
  }).catch(err => {
    return { data: { message: err.message }, status: 'error' }
  })
}

export async function checkOtpProcessApi(data) {  
  let token = decryptStorage(localStorage.getItem("token"))
  let config = {
    method: 'get',
    url: `${API_CLIENT_PROCESS}/ECD/getMailWhitelist`,
    headers: {
      'Authorization': 'Bearer ' + token,
      'Content-Type': 'application/json',
      'email': data.email
    },
  };
  let responseConsultWhiteList = await axios.request(config)
    .then(response => {
      return response.data.data
    }).catch(error => {
      console.log(error)
    });

  //Validacion inicial por listas blancas
  if (responseConsultWhiteList && responseConsultWhiteList.statusMail === true) {
    return { data: { "message": "existing_whitelisted_mail" }, status: 'success' }
  }
}

export async function validateOTP(data) {
  let dataSend = {
    "otp": data.otp,
    "email": data.email,
    "externalRequestId": data.externalRequestId
  }

  let config = {
    method: 'post',
    url: `${API_STRUCTURE}/validate-otp`,
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${decryptStorage(localStorage.getItem("token"))
    }`
    },
    data: dataSend
  };
  return axios.request(config)
    .then(res => {
      if (!res.data.data.error) {
        return { data: res.data.data, status: 'success' }
      } else throw ({ message: res.data.data.error, status: 'error' })
    }).catch(err => {
      console.log("error:", err)
      return { data: { message: err.message }, status: 'error' }
    });
}

export async function identityValidationsApplyApi(data) {
  let token = decryptStorage(localStorage.getItem("token"))
  let config = {
    method: 'get',
    url: `${API_CLIENT_PROCESS}/Consult/getValidations`,
    headers: {
      'Authorization': 'Bearer ' + token,
      'Content-Type': 'application/json',
      "externalRequestId": data.externalRequestId
    }
  };
  
  return axios.request(config)
    .then(response => {
      return response.data
    }).catch(err => {
      console.log("error:", err.response)
      return { data: { message: err?.response?.data?.statusDescription || err.message }, status: 'error' }
    });
}
